export function formatXHRError(xhr, method) {
    var method_lookup = {
        "POST": "adding the record",
        "PATCH": "making your changes",
        "DELETE": "deleting the record",
        "GET": "getting the data",
        undefined: ""
    };

    if (xhr.response) {
        if (xhr.response.statusText) {
            return "Error(s): " + xhr.response.statusText
        }
    }

    return "There was an error" + " " + method_lookup[method] + " (" + xhr.message + ")";
}